/**
 * Ambient-context list settings for field-sales-2 contributions.
 *
 * Client lists ship the full card values (the consuming agent has no other
 * access to what the cards render); flip `INCLUDE_CLIENT_DETAILS` to fall back
 * to ids-only. `limit: undefined` sends everything visible; set a number to
 * cap a list without touching the mappers.
 */
export const INCLUDE_CLIENT_DETAILS = true;

export const CLIENT_LIST_LIMIT: number | undefined = undefined;
export const TODO_LIST_LIMIT: number | undefined = undefined;
export const ANALYSIS_ROW_LIMIT: number | undefined = undefined;

/**
 * Analysis rows coerce a missing KPI to `value: 0` internally while the screen renders
 * `formattedValue ?? "—"`. The envelope must mirror the screen: no formatted value → no value,
 * so the agent never reads a placeholder 0 as a real number.
 */
/**
 * What the rendered breakdown list contains, mirroring the on-screen title logic
 * (a drill step is homogeneous, so the first row classifies it). The absolute
 * hierarchy level is not exposed by the productGroups API.
 */
export const analysisRowsKind = (
  items: readonly { hasChildren: boolean }[],
): "product_groups" | "products" | undefined =>
  items.length === 0 ? undefined : items[0].hasChildren ? "product_groups" : "products";

export const trendItemsToAnalysisRowInputs = (
  items: readonly {
    name: string;
    externalReference: string | null;
    value: number;
    formattedValue: string | null;
    change: number | null;
  }[],
) =>
  items.map((item) => ({
    name: item.name,
    externalReference: item.externalReference,
    value: item.formattedValue === null ? undefined : item.value,
    percentageChange: item.change,
  }));
